<template >
  <div class="container register">
    <v-card class="logincard mx-auto" width="80%">
      <v-card-title
        class="loginmain justify-center text-white"
        style="font-size:28px;   font-family: 'Nunito', sans-serif;"
      >Create an Account</v-card-title>
      <div class="registercard">
        <div class="mt-4">
          <v-row>
            <v-col md="6">
              <v-select
              
            prepend-icon="mdi-account-switch"
                label="Registration Type"
                :items="types"
                v-model="form.type"
              />
            </v-col>
            <v-col md="6">
              <v-text-field
                label="Enter The Set Top Box Number/Smart Card Number Below"
                v-model="form.serialNo"
                prepend-icon="mdi-package-variant-closed"
                placeholder="eg : 60713183.....394"
                type="number"
                @change="checkSTB"
                required
                :error="!stbValid"
              > 
              </v-text-field>
            </v-col>
          </v-row>

          <v-text-field
            required
            prepend-icon="mdi-phone"
            label=" Enter your Mobile Number "
            v-model="form.mobile"
            placeholder="eg : 9999999999"
            type="number"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength = "10"
          />

          <v-text-field

            required
            prepend-icon="mdi-email"
            label="Enter your Email Id "
            v-model="form.email"
            placeholder="eg : 12345"
            type="text"
          />

          <v-text-field
            required
            label="Enter password"
            prepend-icon="mdi-lock"
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'visibility' : 'visibility_off'"
            @click:append="show = !show"
            v-model="form.password"
            placeholder="Should Be Upto 8 characters"
            
          />

          <v-text-field
            label=" Confirm password "
            prepend-icon="mdi-lock"
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? 'visibility' : 'visibility_off'"
            @click:append="show1 = !show1"
            v-model="cPassword"
            placeholder="Should Be Upto 8 characters"
            />

          <div class="form-inline">
            <Button
              rounded
              color="primary"
              cssClass="submit"
              label="Next"
              @click="handleSubmit"
              />
            <router-link to="/login">
              <Button
                text
                color="primary"
                cssClass="submit"
                label="Cancel"
                />
            </router-link>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Button from "@/components/Elements/Button.vue";
import {
  register as registerService,
  verifySTB as verifySTBService
} from '@/services/register';
import { extractError } from '../../utils/error';

export default {
  data() {
    return {
      show: false,
      show1: false,
      form: {
        serialNo: '',
        password: '',
        email: '',
        mobile: '',
        accountNo: '2372327198',
        type: ''
      },
      types: ['Set Top Box', 'Smart Card'],
      cPassword: '',
      stbValid: true,
    };
  },
  computed: {
    isSTB() {
      return this.form.type.match(/S.*T.*B/);
    },
    isSC() {
      return this.form.type.match(/smart.*card/i);
    }
  },
  methods: {
    async handleSubmit() {
      // console.log('submit here : ', this.form);
      try{
        const hasError = this.validate();
        if(hasError) {
          this.$toasted.error(hasError, {
            duration: 2000
          })
          return;
        }
        const { type, ...payload } = { ...this.form };
        payload.serialNoType = type.match(/S.*T.*B.*/) ? 'STB' : 'SC';
        payload.mobile = parseInt(payload.mobile);
        const result = await registerService(payload);
        const { response: { userID: userId } } = result;
        // console.log('got registration result : ', result);
        this.$router.push({
          name: 'Otp',
          params: {
            userId,
            number: payload.mobile,
            forwardedfrom: 'registrationPage'
          }
        });
        // console.log('register service result : ', result);
      }
      catch(err) {
        console.log(err);
        const message = extractError(err);
        this.$showError(message);
      }
    },
    async checkSTB() {
      const { serialNo } = this.form;
      // console.log('stb is : ', serialNo);
      try {
        const payload = {};
        if(this.isSTB) {
          payload.stb = serialNo;
        }
        else {
          payload.scn = serialNo;
        }
        const result = await verifySTBService(payload);
        const { response: { accountNo } } = result;
        // console.log('got result : ', result);
        this.form.accountNo = accountNo;
        this.stbValid = true;
      }
      catch(err) {
        const message = extractError(err);
        // console.log('got err : ', err);
        this.$showError(message);
        this.stbValid = false;
      }
    },
    validate() {
      const { stbValid } = this;
      console.log ('result', this);
      if(this.form.password !== this.cPassword) {
        return 'Passwords are not matching'
      }
      if(!stbValid) {
        return 'Serial No is not valid'
      }
      return null;
    }
  },
  components: {
    Button
  }
};
</script>
<style scoped>
  .register {
    background-image: url("/img/authentication.jpg");
    background-size: cover;
    background-position: center;
    max-width: 100%;
    height: 100%;
  }
  .registercard {
    padding: 2rem;
  }
</style>
